import { gql } from 'apollo-boost';

export const REPLACE_FEED = gql`
  mutation replaceFeed($input: ReplaceFeed) {
    replaceFeed(input: $input)
  }
`;